export const PROGRAM_COMPARISON = {
  "health-optimization": {
    focus: "Whole-person baseline",
    measures: "Labs · wearables · body composition",
    oversight: "Physician guided",
    cadence: "Quarterly review cycle",
  },
  "body-transformation": {
    focus: "Fat loss + lean mass",
    measures: "Composition · hormones · recovery",
    oversight: "Clinical team + physician review",
    cadence: "Biweekly tracking",
  },
  "cognitive-optimization": {
    focus: "Focus + mental energy",
    measures: "Cognition · sleep · inflammation",
    oversight: "Clinical team + physician review",
    cadence: "8–12 week initial phase",
  },
  "hormone-optimization": {
    focus: "Hormonal balance",
    measures: "Sex hormones · thyroid · cortisol",
    oversight: "Physician guided",
    cadence: "Quarterly titration",
  },
  "metabolic-optimization": {
    focus: "Insulin + cellular energy",
    measures: "CGM · insulin · lipids",
    oversight: "Physician guided",
    cadence: "8–16 week initial phase",
  },
  "performance-optimization": {
    focus: "Strength + endurance",
    measures: "VO2 · HRV · training load",
    oversight: "Clinical team + physician review",
    cadence: "Quarterly benchmarks",
  },
  "longevity-optimization": {
    focus: "Healthspan + biological age",
    measures: "Age markers · labs · fitness",
    oversight: "Physician guided",
    cadence: "Annual arc + quarterly markers",
  },
};